import React from 'react'
import * as contentTypes from '../api/contentTypes'
import TextGrid from '../components/organisms/TextGrid'
import ImageText from '../components/organisms/ImageText'
import ImageBackgroundText from '../components/organisms/ImageBackgroundText'
import Intro from '../components/organisms/Intro'
import FullWidthMedia from '../components/organisms/FullWidthMedia'
import Text from '../components/organisms/Text'
import Author from '../components/organisms/Author'
import ContentCarousel from '../components/organisms/ContentCarousel'
import ImageRow from '../components/organisms/ImageRow'
import TestimonialCarousel from '../components/organisms/TestimonialCarousel'
import LinkList from '../components/organisms/LinkList'
import Featured from '../components/organisms/Featured'
import PricingGrid from '../components/organisms/PricingGrid'
import Anchor from '../components/organisms/Anchor'
import HtmlSnippet from '../components/organisms/HtmlSnippet'
import RenewConsent from '../components/organisms/RenewConsent'
import MediaGrid from '../components/organisms/MediaGrid'
import flagDk from '../resources/images/flag-denmark.png'
import flagNo from '../resources/images/flag-norway.png'
import flagSe from '../resources/images/flag-sweden.png'
import flagUk from '../resources/images/flag-uk.png'
import flagCh from '../resources/images/flag-ch.png'
import flagDe from '../resources/images/flag-de.png'
import flagAt from '../resources/images/flag-at.png'
import flagFr from '../resources/images/flag-fr.png'

import LazyLoad from 'react-lazyload'

export const contentModelToBlock = (block, index, { translations }) => {
  if ( block.hideBlockForThisLocale ) {
    return null
  }
  switch (block.contentType) {
    case contentTypes.SIMPLE_TEXT_COLUMNS:
      return <TextGrid key={ index } items={ block.items }/>
    case contentTypes.IMAGE_TEXT:
      return <ImageText key={ index } translations={ translations } { ...block } />
    case contentTypes.INTRO:
      return <Intro key={ index } { ...block } />
    case contentTypes.FULL_WIDTH_MEDIA:
      return <FullWidthMedia key={ index } { ...block }/>
    case contentTypes.TEXT:
      return <Text key={ index } { ...block }/>
    case contentTypes.AUTHOR:
      return <Author key={ index } { ...block }/>
    case contentTypes.CONTENT_CAROUSEL:
      return <LazyLoad height={200} offset={200} once key={ index } > <ContentCarousel translations={translations} { ...block }/> </LazyLoad>
    case contentTypes.IMAGE_ROW:
      return <LazyLoad height={200} offset={200} once key={ index } > <ImageRow { ...block }/> </LazyLoad>
    case contentTypes.TESTIMONIAL_CAROUSEL:
      return <LazyLoad height={200} offset={200} once key={ index } > <TestimonialCarousel { ...block }/> </LazyLoad>
    case contentTypes.LINK_LIST:
      return <LinkList key={ index } { ...block }/>
    case contentTypes.PRICING_GRID:
      return <PricingGrid key={ index } { ...block }/>
    case contentTypes.FEATURED:
      return <Featured key={ index } translations={translations} { ...block }/>
    case contentTypes.ANCHOR:
      return <Anchor key={ index } { ...block }/>
    case contentTypes.IMAGE_BACKGROUND_TEXT:
      return <ImageBackgroundText key={ index } translations={translations} { ...block }/>
    case contentTypes.HTML_SNIPPET:
      return <LazyLoad height={200} offset={200} once key={ index } > <HtmlSnippet { ...block }/> </LazyLoad>
    case contentTypes.RENEW_CONSENT:
      return <RenewConsent key={ index } { ...block }/>
    case contentTypes.MEDIA_GRID:
      return <MediaGrid key={ index } translations={translations} { ...block }/>
  }
}

export const getIconName = icon => {
  switch (icon) {
    case 'Shaka sign':
      return 'icon-shaka-sign'
    case 'Bed':
      return 'icon-bed'
    case 'Surf board':
      return 'icon-surf-board'
    case 'Couple':
      return 'icon-couple'
    case 'Group':
      return 'icon-group'
    case 'World':
      return 'icon-world'
    case 'Mail':
      return 'icon-mail'
    case 'Open book':
      return 'icon-open-book'
    case 'Facebook':
      return 'icon-facebook'
    case 'Instagram':
      return 'icon-instagram'
    case 'Twitter':
      return 'icon-twitter'
    case 'Vimeo':
      return 'icon-vimeo'
    case 'Youtube':
      return 'icon-youtube'
    case 'Spotify':
      return 'icon-spotify'
    case 'Wave':
      return 'icon-wave'
  }
}


export const getLocaleInfo = localeCode => {
  switch (localeCode) {
    case 'en-GB':
    case 'en-US':
      return {
        code: localeCode,
        name: 'English',
        flag: flagUk,
        link: "https://www.lapointcamps.com/",
        language: 'UK',
        currency: 'EUR',
        currencyDisplay: '€',
        newsLetterGroupId: '8'
      }
    case 'sv-SE':
      return {
        code: localeCode,
        name: 'Svenska',
        flag: flagSe,
        link: "https://www.lapoint.se/",
        language: 'SE',
        currency: 'SEK',
        currencyDisplay: 'SEK ',
        newsLetterGroupId: '2'
      }
    case 'nb-NO':
      return {
        code: localeCode,
        name: 'Norsk',
        flag: flagNo,
        link: "https://www.lapoint.no/",
        language: 'NO',
        currency: 'NOK',
        currencyDisplay: 'NOK ',
        newsLetterGroupId: '1'
      }
    case 'da-DK':
      return {
        code: localeCode,
        name: 'Dansk',
        flag: flagDk,
        link: 'https://www.lapoint.dk/',
        language: 'DK',
        currency: 'DKK',
        currencyDisplay: 'DKK ',
        newsLetterGroupId: '4'
      }
    case 'de-DE':
      return {
        code: localeCode,
        name: 'Deutsch',
        flag: flagDe,
        link: 'https://www.lapoint.de/',
        language: 'DE',
        currency: 'EUR',
        currencyDisplay: '€',
        newsLetterGroupId: '32'
      }
    case 'de-CH':
      return {
        code: localeCode,
        name: 'Schweizerdeutsch',
        flag: flagCh,
        link: 'https://www.lapoint.ch/',
        language: 'DE',
        currency: 'EUR',
        currencyDisplay: '€',
        newsLetterGroupId: '64'
      }
    case 'de-AT':
      return {
        code: localeCode,
        name: 'Österreichisches Deutsch',
        flag: flagAt,
        link: 'https://www.lapoint.at/',
        language: 'DE',
        currency: 'EUR',
        currencyDisplay: '€',
        newsLetterGroupId: '128'
      }
    case 'fr-FR':
      return {
        code: localeCode,
        name: 'Français',
        flag: flagFr,
        link: 'https://www.lapoint.fr/',
        language: 'FR',
        currency: 'EUR',
        currencyDisplay: '€',
        newsLetterGroupId: '256'
      }
  }
}
